import { createReducer } from "redux-act";

import {
  REQNotificationList,
  RESNotificationList,
  FailNotificationList,
  SENDxNotification,
  DELxNotification,
  SETxNotificationStatus,
  CleanUpNotificationList
} from "./actions";

const initialState = {
  REQStrNotificationList: false,
  NotificationList: [],
  Pagination: { page: 1, limit: 20, total: 0, totalPages: 0 },
  errorMessage: false
};

const notificationListReducer = createReducer(
  {
    [REQNotificationList]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [SENDxNotification]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [DELxNotification]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [SETxNotificationStatus]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [RESNotificationList]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationList: false,
        NotificationList: payload.data || [],
        Pagination: payload.pagination || initialState.Pagination,
        errorMessage: false
      };
    },

    [FailNotificationList]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationList: false,
        errorMessage: (payload && payload.message) || "โหลดรายการแจ้งเตือนไม่สำเร็จ"
      };
    },

    [CleanUpNotificationList]: () => {
      return initialState;
    }
  },

  initialState
);

export default notificationListReducer;
